import { useQuery } from '@tanstack/react-query';
import { useServices } from '../../../../core/contexts/useServices';

export function accountQueryKey(accountId: string) {
  return ['accounts', accountId] as const;
}

export function useAccount(accountId: string | undefined) {
  const { accountService } = useServices();
  return useQuery({
    queryKey: accountId ? accountQueryKey(accountId) : (['accounts', null] as const),
    queryFn: () => accountService.getAccountById(accountId!),
    enabled: !!accountId,
  });
}
